import { Component } from "./base/copmonent";
import { ensureElement } from "../utils/utils";
export class Success extends Component {
    constructor(container, actions) {
        super(container);
        this._close = ensureElement('.order-success__close', this.container);
        this._descriptionTotl = ensureElement('.order-success__description', this.container);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            this._close.addEventListener('click', actions.onClick);
        }
    }
    set descriptionTotl(value) {
        this._descriptionTotl.textContent = `Списано ${value} синапсов`;
    }
}
